import { UserActions } from '@next/core-lib/user';
import { createReducer, on } from '@ngrx/store';

import { MilkDeliveryState } from '../../models/milk-delivery.model';

import * as MilkDeliveryActions from '../actions/milk-delivery.actions';

export const initialState: MilkDeliveryState = {
  milkDeliverySummary: null,
  milkDeliveryMonthSummary: null,
};

export const milkDeliveryReducer = createReducer<MilkDeliveryState>(
  initialState,
  on(MilkDeliveryActions.loadMilkDeliveriesSuccess, (state, { milkDeliverySummary }) => ({
    ...state,
    milkDeliverySummary,
  })),
  on(UserActions.relationshipSelected, () => initialState),
  on(
    MilkDeliveryActions.loadMilkDeliveriesMonthSummarySuccess,
    (state, { milkDeliveryMonthSummary }) => ({
      ...state,
      milkDeliveryMonthSummary,
    }),
  ),
);
